import { Injectable } from '@angular/core';
import { Category } from '@df/catalog/category/category';
import { Resource } from '@df/catalog/resource';

declare module '@df/catalog/resource' {
    interface IResources {
        category: Resource<Category, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class CategoryResource extends Resource<Category, number> {
    static override instance = Category;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = true;
}
